module.exports = __webpack_public_path__ + "img/polokwane-city.723302d1.png";